import { useNavigate } from 'react-router-dom';
import { Heart, Mail, Clock } from 'lucide-react';

export default function Contact() {
  const navigate = useNavigate();

  return (
    <div className="app-container">
      <div className="px-4 py-6 pb-20">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <button onClick={() => navigate('/')} className="text-white">
            ← Back
          </button>
          <Heart className="text-primary fill-primary" size={24} />
          <div className="w-8" />
        </div>

        <h1 className="text-white font-bold text-3xl mb-6">Contact Us</h1>

        <div className="space-y-6">
          {/* Company Info */}
          <div className="glass rounded-2xl p-6 border border-primary/20">
            <h2 className="text-white font-semibold text-xl mb-4">BlindMatch</h2>
            <p className="text-gray-400 text-sm mb-4">
              Anonymous dating platform where connections are built on conversation, not appearances.
            </p>
            
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <Mail className="text-primary mt-1" size={20} />
                <div>
                  <p className="text-white font-medium">Email</p>
                  <a href="mailto:support@blindmatch.in" className="text-primary hover:underline">
                    support@blindmatch.in
                  </a>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <Clock className="text-primary mt-1" size={20} />
                <div>
                  <p className="text-white font-medium">Support Hours</p>
                  <p className="text-gray-300">
                    24/7 - We're always here to help
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Support Categories */}
          <div className="space-y-4">
            <h2 className="text-white font-semibold text-lg">How can we help?</h2>
            
            <div className="glass rounded-xl p-4 border border-white/10">
              <h3 className="text-white font-medium mb-2">Payment Issues</h3>
              <p className="text-gray-400 text-sm">
                For payment failures, refund requests, or billing inquiries, email us at{' '}
                <a href="mailto:payments@blindmatch.in" className="text-primary hover:underline">
                  payments@blindmatch.in
                </a>
              </p>
            </div>
            
            <div className="glass rounded-xl p-4 border border-white/10">
              <h3 className="text-white font-medium mb-2">Account & Technical Support</h3>
              <p className="text-gray-400 text-sm">
                For login issues, account recovery, or technical problems, email us at{' '}
                <a href="mailto:support@blindmatch.in" className="text-primary hover:underline">
                  support@blindmatch.in
                </a>
              </p>
            </div>
            
            <div className="glass rounded-xl p-4 border border-white/10">
              <h3 className="text-white font-medium mb-2">Safety & Report Concerns</h3>
              <p className="text-gray-400 text-sm">
                To report inappropriate behavior, harassment, or safety concerns, email us at{' '}
                <a href="mailto:safety@blindmatch.in" className="text-primary hover:underline">
                  safety@blindmatch.in
                </a>
              </p>
            </div>
            
            <div className="glass rounded-xl p-4 border border-white/10">
              <h3 className="text-white font-medium mb-2">Privacy & Data Requests</h3>
              <p className="text-gray-400 text-sm">
                For data deletion requests or privacy concerns, email us at{' '}
                <a href="mailto:privacy@blindmatch.in" className="text-primary hover:underline">
                  privacy@blindmatch.in
                </a>
              </p>
            </div>
          </div>

          {/* Response Time */}
          <div className="glass rounded-xl p-4 border border-green-500/30">
            <p className="text-green-400 text-sm">
              <span className="font-semibold">24/7 Support:</span> We typically respond within 24 hours. For urgent matters, please include "URGENT" in your email subject.
            </p>
          </div>

          {/* Social Links */}
          <div className="text-center pt-4">
            <p className="text-gray-400 text-sm mb-2">Follow us on social media</p>
            <div className="flex justify-center gap-4">
              <a href="https://instagram.com/blindmatch.in" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary transition-colors">
                Instagram
              </a>
              <a href="https://twitter.com/blindmatch_in" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary transition-colors">
                Twitter
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
